import { cva, type VariantProps } from 'class-variance-authority';

import styles from './icon.module.scss';

export type IconVariantProps = VariantProps<typeof iconVariants>;
export const iconVariants = cva(styles.icon, {
  variants: {
    color: {
      black: styles['color--black'],
      white: styles['color--white'],
      blue: styles['color--blue'],
      green: styles['color--green'],
      grey: styles['color--grey'],
    },
    size: {
      xxsm: styles['size--xxsm'],
      xsm: styles['size--xsm'],
      sm: styles['size--sm'],
      md: styles['size--md'],
      lg: styles['size--lg'],
      xlg: styles['size--xlg'],
      xxlg: styles['size--xxlg'],
      xxxlg: styles['size--xxxlg'],
    },
  },
  defaultVariants: {
    color: 'white',
    size: 'sm',
  },
});

export type IconProps = {
  className?: string;
  opacity?: number;
} & IconVariantProps;
